module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_1@2x.f8061bab.png";